import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery } from './baseQuery';
import type { IScenario, IScenarioPurpose } from '../scenarios.types';
import { formulasApi } from './formulas/formulasApi';

interface IListScenariosParams {
  orgUuid: string;
  purpose?: IScenarioPurpose;
}

interface IMergeScenarioParams {
  orgUuid: string;
  scenarioUuid: string;
  scenariosToAwait?: string[];
}

export const scenariosApi = createApi({
  reducerPath: 'scenariosApi',
  baseQuery: createBaseQuery(),
  tagTypes: ['Scenario', 'Formula'],
  endpoints: (builder) => ({
    listScenarios: builder.query<IScenario[], IListScenariosParams>({
      query: ({ orgUuid, purpose }) => ({
        url: `organizations/${orgUuid}/scenarios`,
        params: {
          purpose,
        },
      }),
      transformResponse: (response: { data: IScenario[] }) => {
        return response.data;
      },
      keepUnusedDataFor: 300, // 5 minutes
      providesTags: ['Scenario'],
    }),
    mergeScenario: builder.mutation<void, IMergeScenarioParams>({
      query: ({ orgUuid, scenarioUuid, scenariosToAwait }) => ({
        url: `organizations/${orgUuid}/scenarios/${scenarioUuid}/merge`,
        method: 'POST',
        params: {
          scenariosToAwait,
        },
      }),
      invalidatesTags: ['Scenario'],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          // Manually invalidate the Formula tag in formulasApi
          dispatch(formulasApi.util.invalidateTags(['Formula']));
        } catch {
          // Do nothing
        }
      },
    }),
  }),
});

export const { useListScenariosQuery, useMergeScenarioMutation } = scenariosApi;
